/* eslint-disable react/require-default-props */
import React from 'react';

import { RecruiterTable } from './RecruiterTable';
import { useStoreState } from '../../../../../models/hooks';

function RecruiterListTableComponent({ selectedStatus = 'all' }: { selectedStatus?: string }) {
  const { selectedPosition, filteredRecruiters: recruiters, isRecruitersLoading } = useStoreState(
    (state) => state.moniterByRecruiters,
  );

  const filteredRecruiters = React.useMemo(() => {
    /* istanbul ignore next */
    if (selectedStatus === 'all') return recruiters;
    if (selectedStatus === 'following')
      return recruiters?.filter((r) => selectedPosition?.assignedRecruiters?.find((p) => p.id === r.id));
    if (selectedStatus === 'watching')
      return recruiters?.filter((r) => selectedPosition?.watchedRecruiters?.find((p) => p.id === r.id));
    return recruiters?.filter(
      (r) =>
        !selectedPosition?.assignedRecruiters?.some((p) => p.id === r.id) &&
        !selectedPosition?.watchedRecruiters?.some((p) => p.id === r.id),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedStatus, recruiters, selectedPosition?.assignedRecruiters, selectedPosition?.watchedRecruiters]);

  if (!selectedPosition) return null;
  return (
    <RecruiterTable
      recruiters={filteredRecruiters}
      allRecruitersCount={recruiters.length}
      position={selectedPosition}
      isLoading={isRecruitersLoading}
    />
  );
}

export const RecruiterListTable = React.memo(RecruiterListTableComponent);
